import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Validation, currencyExchange, countryCallingCodes, searchCountry, Razorpay } from "../../helper/function"
import AxiosInstance from '../../helper/AxiosInstance'
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import PaymentLoader from './Componnents/PaymentLoader'

export default function PricingPage() {
    const subbtn = useRef(null)
    const navigate = useNavigate()
    const { currencyId, packageId } = useParams();
    const [action, setAction] = useState({ preLoader: false, btnLoader: false, couponLoader: false, haveCoupon: false, message: '', couponNo: '', wpCredit: false })
    const [countrys, setCountrys] = useState(countryCallingCodes);
    const [industries, setIndustries] = useState([]);
    const [data, setData] = useState({ packageId: packageId, industry: "", numofemp: 5, firstname: '', lastname: '', mobile: '', email: '', organization: '', gstno: '', country: 'India', state: '', city: '', pincode: '', address: '', couponCode: '', couponValue: 0, callingCode: { country: "India", code: "+91" }, })

    const GetInputs = (event) => {
        Validation(event)
        const target = event.currentTarget;
        setData((prev) => ({ ...prev, [target.name]: target.value }))
        setAction((prev) => ({ ...prev, errors: null, message: null }))
    };

    const fetchIndustries = async () => {
        try {
            const response = await AxiosInstance.get('/public/industries');
            if (response.status === "success") { setIndustries(response.data); }
        } catch (error) { }
    }

    const fetcPackage = async () => {
        try {
            setAction((prev) => ({ ...prev, preLoader: true }))
            const response = await AxiosInstance.get(`/public/packages/${packageId}`);
            if (response.status === 1) {
                const currency = (currencyExchange || []).find(cry => cry.id == currencyId)
                setData((prev) => ({ ...prev, ...currency, ...response.data, numofemp: parseInt(response.data.limitation) }));
            }
        } catch (error) { } finally { setAction((prev) => ({ ...prev, preLoader: false })) }
    }

    const verfyCoupon = async (event) => {
        event.preventDefault();
        try {
            setAction((prev) => ({ ...prev, couponLoader: true }))
            if (!data.email) { toast.warn('First enter your email then apply coupon..!!', { autoClose: 700, position: 'top-center' }); return }
            else if (!(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(data.email)) { toast.warn('Enter valid email..!!'); return }
            const response = await AxiosInstance.post('/public/checkcoupon', { email: data.email, couponNo: action.couponNo });
            if (response.status === 'success') {
                setData((prev) => ({ ...prev, ...response.data }))
            } else {
                toast.warn(response.message, { autoClose: 700, position: 'top-center' })
            }
        } catch (err) {
            toast.error(err.message, { autoClose: 700, position: 'top-center' })
        } finally {
            setAction((prev) => ({ ...prev, couponLoader: false }))
        }
    }

    const PayNow = async (event) => {
        event.preventDefault();
        try {
            if(!data?.numofemp && data?.numofemp<5){toast.error('Minimum users can be 5', { autoClose: 700, position: 'top-center' }); return }
            setAction((prev) => ({ ...prev, message: null, btnLoader: true }))
            const response = await AxiosInstance.post('/public/generate-payment-link', data);
            if (response.status === 1) {
                const options = { ...response.data, modal: { ondismiss: function () { setAction((prev) => ({ ...prev, btnLoader: false })) } } };
                await Razorpay(options);
            } else if (response.status === 3) {
                navigate(`/transaction/${response.tenanttransaction}`)
            } else {
                setAction((prev) => ({ ...prev, btnLoader: false, errors: response.data, message: response.message }))
                toast.error(response.message, { autoClose: 700, position: 'top-center' });
            }
        } catch (err) { } finally {
            setAction((prev) => ({ ...prev, btnLoader: false }))
        }
    }

    const verfyemployee = () => {
        if(data.numofemp<5){
            toast.error(`Minimum ${parseInt(data.limitation)} employees allowed`, { autoClose: 700, position: 'top-center' });
            setData((prev)=>({...prev, numofemp: parseInt(data.limitation)}))
        }
    }

    useEffect(() => {
        fetchIndustries();
        fetcPackage()
    }, [])

    useEffect(() => {
        setData((prev) => {
            const mrp = Number(prev.mrp || 0)
            const discount = Number(prev.discount || 0)
            const price = Number(prev.price || 0)
            const duration = Number(prev.duration || 0)
            const gst = Number(prev.gst || 0)
            const currencyRate = Number(prev.currencyRate || 0)
            const nomOfEmp = Number(prev.numofemp || 0)
            const couponValue = Number(prev.couponValue || 0)
            const creditRate = Number(prev.creditRate || 0)
            const creditValue = Number(prev.creditValue || 0)

            const totalMrp = mrp * duration
            const pricePerPerson = price * duration
            const subTotal = pricePerPerson * nomOfEmp
            const creditAmount = creditValue * creditRate
            const amount  = subTotal + creditAmount;
            const gstAmount = (amount / 100) * gst
            const totalAmount = amount + gstAmount 

            const couponAmount = (totalAmount / 100) * couponValue
            const payableAmount = totalAmount - couponAmount
            const discountAmount = ((totalMrp * nomOfEmp) / 100) * discount
            const saveAmount = discountAmount + couponAmount

            // calculation for updated view
            const displayMrp = totalMrp / currencyRate;
            const discountedPrice = (displayMrp * (discount/100));  // math.ceil
            let amountAfterDiscount = (displayMrp - discountedPrice);   // math.ceil

            let newSubTotal = (amountAfterDiscount * nomOfEmp)  // math.ceil
            let newSubTotalAfterCoupon = newSubTotal
            
            // if coupon applied
            const couponDiscountAmt = (newSubTotal * (couponValue/100)) // math.ceil
            newSubTotalAfterCoupon = newSubTotal - couponDiscountAmt ?? newSubTotal

            // if whatsapp credit 
            let whatsappCreditTotalAmt = creditValue ?  (creditValue * creditRate) : 0  // math.ceil

            const gstAmt = ((whatsappCreditTotalAmt + newSubTotalAfterCoupon) * (gst/100)); // math.ceil
            
            let netPayable = (whatsappCreditTotalAmt + newSubTotalAfterCoupon + gstAmt) // math.ceil


            // calculate Amt without discounts
            const tots = ((displayMrp * nomOfEmp) + whatsappCreditTotalAmt)
            const totsgst = tots * (gst/100)
            const amtWithoutDiscounts =  Math.ceil(tots + totsgst)
            

            return {
                ...prev,
                displayMrp: totalMrp / currencyRate,
                displayPrice: pricePerPerson / currencyRate,
                subTotal: subTotal / currencyRate,
                creditAmount: creditAmount / currencyRate,
                gstTotal: gstAmount / currencyRate,
                totalAmount: totalAmount,
                saveAmount: saveAmount / currencyRate,
                couponAmount: couponAmount / currencyRate,
                payableAmount: payableAmount / currencyRate,
                
                // calculation for updated view
                discountedPrice: discountedPrice,
                gstAmt: gstAmt,
                newSubTotal: newSubTotal,
                newSubTotalAfterCoupon: newSubTotalAfterCoupon,
                netPayable: netPayable,
                amtWithoutDiscounts: amtWithoutDiscounts,
                amountAfterDiscount: amountAfterDiscount,
                couponDiscountAmt: couponDiscountAmt,
                whatsappCreditTotalAmt: whatsappCreditTotalAmt,
            }
        })

    }, [data.currencyRate, data?.numofemp, data?.couponValue, data.creditValue])

    console.log("data: ", data);
    
    return (
        <>
            <Helmet>
                <title>PlanDetails | Taskflier </title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            {action.preLoader && <PaymentLoader /> }
                <div>
                    <div class="user-data-page clearfix d-lg-flex bg-white row">
                        <form method="post" onSubmit={PayNow} class="illustration-wrapper pricing d-flex align-items-center col-md-7 justify-content-between flex-column">
                            <div className="planform">
                                <div className="row" >
                                    <div className="col-12 col-md-12">
                                        <h3 class=" pt-0 font-20 pb-20 biltitle text-left">Billing Details </h3>
                                        {action.message && <div class="alert alert-danger text-center" role="alert">{action.message}</div>}
                                        <div className="">
                                            <div className="row planinput">
                                                <div className="mb-2 col-6">
                                                    <label for="example-email" class="form-label">Select Industry</label>
                                                    <select class="form-select" id="industry" name="industry" onChange={GetInputs} required>
                                                        <option selected={data.industry == '' ? true : false} value="">Select</option>
                                                        {(industries || []).map((industry) => <option key={industry._id} value={industry._id}>{industry.name}</option>)}
                                                    </select>
                                                    <small className="text-danger">{action?.errors?.industry?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-2 col-6">
                                                    <label for="example-email" class="form-label">Number of Employees</label>
                                                    <input min={5} type="text" class="form-control" name="numofemp" data-type="numeric" maxLength="5" onChange={GetInputs} id="emp" placeholder="enter no of employee" value={data?.numofemp && parseFloat(data.numofemp) > 0 ? data.numofemp : ''} onBlur={verfyemployee} required />
                                                    <label htmlFor="emp"></label>
                                                    <small className="text-danger">{action?.errors?.numofemp?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-2 col-6">
                                                    <label for="firstname" class="form-label">First Name</label>
                                                    <input  type="text" class="form-control" name="firstname" onChange={GetInputs} id="firstname" placeholder="enter first name" data-type="alphawithspace" maxLength="50" value={data.firstname} required />
                                                    <small className="text-danger">{action?.errors?.firstname?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-2 col-6">
                                                    <label for="firstname" class="form-label">Last Name</label>
                                                    <input type="text" class="form-control" name="lastname" placeholder="enter last name" onChange={GetInputs} id="lastname" data-type="alphawithspace" maxLength="50" value={data.lastname} />
                                                    <small className="text-danger">{action?.errors?.lastname?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-2 col-6">
                                                    <label for="example-email" class="form-label">Email address</label>
                                                    <input type="email" class="form-control" name="email" onInput={GetInputs} placeholder="enter email name" id="floatingInput" data-type="alphanumericwithsymble" maxLength="60" value={data.email} disabled={data.couponCode ? true : false} required />
                                                    <small className="text-danger">{action?.errors?.email?.message ?? ''}</small>
                                                </div>
                                                <div class="mb-2 col-6">
                                                    <label class="form-label">Mobile</label>
                                                    <div className="clearfix"></div>
                                                    <div className="d-flex align-items-center">
                                                        <button class="btn btn-outline-secondary dropdown-toggle form-control w-25 input-group-text" type="button" data-bs-toggle="dropdown" aria-expanded="false">{data.callingCode?.code ? data.callingCode.code : "Code"}</button>
                                                        <ul class="dropdown-menu" style={{ height: "400px", overflow: "scroll" }}>
                                                            <li style={{ cursor: "pointer" }}><input onChange={(event) => setCountrys(searchCountry(event))} className="form-control" /></li>
                                                            {countrys.map((country) => { return (<li style={{ cursor: "pointer" }} onClick={() => setData((prev) => ({ ...prev, callingCode: { country: country.name, code: country.code }, country: country.name }))}><span class="dropdown-item">{country.name}</span></li>) })}
                                                        </ul>
                                                        <input class="form-control"  name="mobile" value={data.mobile} id="monile" type="text" placeholder="enter mobile number" data-type="numeric" maxLength="15" onChange={GetInputs} required />
                                                        <small className="text-danger">{action?.errors?.mobile?.message ?? ''}</small>
                                                    </div>
                                                </div>
                                                <div className="mb-2 col-6">
                                                    <label for="example-email" class="form-label">Organization Name</label>
                                                    <input type="text" class="form-control" id="organization" value={data.organization} placeholder="enter Organization name" name="organization" data-type="alphanumericwithsymblehspace" maxLength="60" onChange={GetInputs} required />
                                                    <small className="text-danger">{action?.errors?.organization?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-2 col-6">
                                                    <label for="example-email" class="form-label">GSTIN</label>
                                                    <input  type="text" class="form-control" name="gstno" data-type="alphanumeric" maxLength="15" onChange={GetInputs} placeholder="enter GSTIN no" id="gstno" value={data.gstno} />
                                                    <small className="text-danger">{action?.errors?.gstno?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-2 col-6">
                                                    <label for="example-email" class="form-label">Country</label>
                                                    <input readOnly type="text" class="form-control" name="country" onInput={GetInputs} placeholder="enter country name" id="country" value={data.country} required />
                                                    <small className="text-danger">{action?.errors?.country?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-2 col-6">
                                                    <label for="example-email" class="form-label">State</label>
                                                    <input type="text" class="form-control" name="state" data-type="alphawithspace" maxLength="50" onChange={GetInputs} id="state" placeholder="enter State name" value={data.state} required />
                                                    <small className="text-danger">{action?.errors?.state?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-3 col-6">
                                                    <label for="example-email" class="form-label">City</label>
                                                    <input type="text" class="form-control" name="city" data-type="alphawithspace" maxLength="50" onInput={GetInputs} id="city" placeholder="enter city name" value={data.city} required />
                                                    <small className="text-danger">{action?.errors?.city?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-3 col-6">
                                                    <label for="example-email" class="form-label">Pin Code</label>
                                                    <input type="text" class="form-control" name="pincode" data-type="numeric" maxLength="6" onInput={GetInputs} id="pincode" placeholder="enter pincode name" value={data.pincode} required />
                                                    <small className="text-danger">{action?.errors?.pincode?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-3 col-12 mb-3  text-left">
                                                    <label for="example-email" class="form-label">Address</label>
                                                    <input class="form-control" name="address" data-type="alphanumericwithsymblehspace" maxLength="100" onInput={GetInputs} id="address" placeholder="enter address" value={data.address} required />
                                                    <small className="text-danger">{action?.errors?.address?.message ?? ''}</small>
                                                </div>
                                                <div className="mb-3 col-12" hidden>
                                                    <button type="submit" className="btn btn-primary w-100" id="submitform" ref={subbtn} hidden></button>
                                                </div>
                                            </div>
                                        </div>

                                </div>

                            </div>
                        </div>
                    </form>
                    <div class="form-wrapper col-md-5 pa-5">
                        <div class="user-data-form mt-20">
                            <h3 className="pb-30 font-20">Payment Summary </h3>
                            <div className="billbox">
                                <ol class="list-group">
                                    <li class="list-group-item d-flex justify-content-between border-bottom align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="font-16">Plan</div>
                                            <small className="font-14">Duration</small>
                                        </div>
                                        <span class=""> {data.plan ?? ''}
                                            <br></br>
                                            <small className="font-14">{data.duration ?? ''} Month</small>
                                        </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="font-14">Date</div>

                                        </div>
                                        <span class="font-14">{new Date().toUTCString().slice(5, 16)}</span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="font-14 fw-semibold">MRP (per user)</div>
                                            <div className="font-14">Discount ({data?.discount ?? ""}%)</div>
                                            <div className="font-14">Price (per user)</div>
                                            <div className="font-14">Sub Total x ({data.numofemp} users)</div>
                                            {
                                                data?.couponValue
                                                ?
                                                <div className="font-14">
                                                    Coupon Discount ({data?.couponValue ?? ""})%
                                                    {/* <p className="text-success font-10 p-0 m-0">
                                                        {
                                                            data?.couponValue && data.couponCode 
                                                            ?
                                                            `(${data.couponCode})`
                                                            : 
                                                            ""
                                                        }
                                                    </p> */}

                                                </div>
                                                :
                                                ""

                                            }
                                            {
                                                data?.creditValue && action.wpCredit
                                                ?
                                                <div className="font-14">Whatsaap Credit ( {data?.creditValue} x {data?.currencySymbol}{Number(data?.creditRate || 0).toFixed(2)})</div>
                                                :
                                                ""

                                            }
                                            <div className="font-14">GST ({data?.gst ?? ""}%)</div>
                                            
                                            {/* <div className="font-14">Net Payable x ({data.numofemp} users)</div> */}

                                        </div>
                                        <span class="">
                                             <small className="font-14 fw-semibold">{data?.currencySymbol}{(data?.displayMrp || 0).toFixed(2)}</small>
                                            <br></br>
                                            {/* discount */}
                                            <small className="font-14">-{data?.currencySymbol}{(data?.discountedPrice ?? 0).toFixed(2)}</small><br></br>

                                            {/* Price */}
                                            <small className="font-14">{data?.currencySymbol}{(data?.amountAfterDiscount ?? 0).toFixed(2)}</small><br></br>

                                            {/* sub total */}
                                            {
                                                data?.couponValue
                                                ?
                                                <small className="text-muted font-14 text-decoration-line-through ms-2">
                                                    ({data?.currencySymbol}{(data?.newSubTotal || 0).toFixed(2)})
                                                </small>
                                                :
                                                ""
                                            }
                                            <small className="font-14">
                                                {data?.currencySymbol}{(data?.newSubTotalAfterCoupon || 0).toFixed(2)}
                                            </small>
                                            <br></br>

                                            {/* Coupon discount Amnt */}
                                            {
                                                data?.couponValue
                                                ?
                                                <>
                                                    <small className="font-14">{data?.currencySymbol}{(data?.couponDiscountAmt || 0).toFixed(2)}</small>
                                                    <br></br>
                                                </>
                                                :
                                                ""
                                            }

                                            {/* whatsapp credit */}
                                            {
                                                data?.creditValue && action.wpCredit
                                                ?
                                                <>
                                                    <small className="font-14">
                                                        {data?.currencySymbol}{(data?.whatsappCreditTotalAmt || 0).toFixed(2)}
                                                    </small>
                                                    <br />
                                                </>
                                                :
                                                ""

                                            }

                                            {/* gst */}
                                            <small className="font-14">{data?.currencySymbol}{(data?.gstAmt ?? 0).toFixed(2)}</small>
                                            <br></br>
                                            
                                            {/* net payable */}
                                            {/* <small className="font-14">{data?.currencySymbol}{(data?.netPayable || 0).toFixed(2)}</small> */}
                                        </span>
                                    </li>
                                    {/* {
                                        data?.creditValue && action.wpCredit ? <li class="list-group-item d-flex justify-content-between align-items-start">
                                            <div class="ms-2 me-auto">
                                                <div class="font-14">Whatsapp Credit</div>
                                                <div className="font-14">Credit Amount ({data?.currencySymbol}{Number(data?.creditRate || 0).toFixed(2)})</div>
                                            </div>
                                            <span class="font-14">{(data?.creditValue || 0).toString().padStart(2, '0')}
                                                <br></br>
                                                <small className="font-14">{data?.currencySymbol}{(data?.creditAmount || 0).toFixed(2)}</small>
                                            </span>
                                        </li> : ''
                                    } */}
                                    {/* <li class="list-group-item d-flex justify-content-between align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="font-14">GST %</div>
                                            <div className="font-14">GST Amount</div>
                                        </div>
                                        <span class="font-14">{data?.gst}%
                                            <br></br>
                                            <small className="font-14">{data?.currencySymbol}{(data?.gstTotal || 0).toFixed(2)}</small>
                                        </span>
                                    </li> */}
                                    {/* <li class="list-group-item d-flex justify-content-between align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="font-14 font-bold">Total Amount</div>
                                            {data?.discount && !data?.couponValue ? <div className="font-14">Total Save</div> : ''}
                                        </div>
                                        <span class="font-14">{data?.currencySymbol}{(data?.totalAmount || 0).toFixed(2)}
                                            <br></br> {data?.discount && !data?.couponValue ? <small className="font-14  text-success">{data?.currencySymbol}{(data?.saveAmount || 0).toFixed(2)}</small> : ''}
                                        </span>
                                    </li> */}
                                    {/* {
                                        data?.couponValue ? <li class="list-group-item d-flex justify-content-between align-items-start">
                                            <div class="ms-2 me-auto">
                                                <div class="font-14 font-bold">Coupon Value</div>
                                                <div className="font-14">Discount Amount</div>
                                                <div className="font-14">Payable Amount</div>
                                                <div className="font-14">Total Save</div>
                                            </div>
                                            <span class="font-14">
                                                {data?.couponValue.toString().padStart(2, '0')}% <br />
                                                {data?.currencySymbol}{(data?.couponAmount || 0).toFixed(2)}<br />
                                                {data?.currencySymbol}{(data?.payableAmount || 0).toFixed(2)}<br />
                                                <span className="text-success">{data?.currencySymbol}{(data?.saveAmount || 0).toFixed(2)}</span>

                                            </span>
                                        </li>
                                            : ""
                                    } */}
                                    
                                    <li class="list-group-item d-flex justify-content-between align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="text-success font-15 fw-semibold">Net Payable</div>
                                        </div>
                                        <span class="text-success font-15 fw-semibold">{data?.currencySymbol}{(data?.netPayable || 0).toFixed(2)}</span>
                                    </li>
                                </ol>
                                <div className="d-flex justify-content-end">
                                    <span className="font-14 text-primary">You saved {data?.currencySymbol}{((data?.amtWithoutDiscounts - data?.netPayable) ?? 0).toFixed(2)}</span>
                                </div>
                            </div>
                            <div style={{display: "none"}} className="d-flex justify-content-between my-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="whatsappCredit" onChange={(event) => { setAction({ ...action, wpCredit: event.currentTarget.checked }); setData((prev)=>({...prev, creditValue: 0 }))}} />
                                    <label class="form-check-label text-center font-rubik copyright-text font-16 themecolor" htmlFor="whatsappCredit"><small> I Want Whatsapp Credit</small> </label>
                                </div>
                                <div>
                                    {action?.wpCredit ? <input type="text" class="form-control form-control-sm" data-type="numeric" maxLength="5" placeholder="Credit Value" name="creditValue" value={data?.creditValue || ''} onInput={GetInputs} onBlur={(event)=>{
                                        const value = event.currentTarget.value 
                                        if(Number(value || 0) && value<500){
                                            toast.warn('Minimum 500 credit allow',{ position: 'top-center', autoClose: 700 })
                                            setData(prev=>({...prev, creditValue: 500 }))
                                        }
                                    }} required /> : ''}
                                </div>
                            </div>
                            <div class="row">
                                {
                                    action.haveCoupon && !data.couponCode && <form class="input-group mt-3 mb-3" onSubmit={verfyCoupon}>
                                        <input type="text" class="form-control font-14" placeholder="Enter coupon/partner code" value={action.couponNo} onInput={(event) => { const target = event.currentTarget; setAction((prev) => ({ ...prev, couponNo: target.value })) }} required />
                                        {action.loader ? <button class="btn btn-theme text-white font-14" type="button" id="button-addon1" disabled><div class="spinner-border" role="status" style={{ width: '17px', height: '17px' }}></div></button> : <button class="btn btn-theme text-white font-14" type="submit" id="button-addon1">Apply</button>}
                                    </form>
                                }
                                <div class="col-12 mt-3">
                                {data?.couponValue && data.couponCode ? <div class="alert text-success font-14 text-center pt-1 pb-1 mb-1" role="alert">
<strong>{data.couponCode}</strong> coupon successfully applied
</div>  : ""}</div>
                                {action.haveCoupon ? <p className="text-center font-13 text-danger noselect"><span onClick={() => { setData((prev) => ({ ...prev, couponCode: '', couponValue: 0 })); setAction((prev) => ({ ...prev, couponNo: '', haveCoupon: !prev.haveCoupon })) }}>Cancel</span></p> : <p className="text-center font-13 text-success noselect"><span onClick={() => { setData((prev) => ({ ...prev, couponCode: '', couponValue: 0 })); setAction((prev) => ({ ...prev, couponNo: '', haveCoupon: !prev.haveCoupon })) }}>I Have a Coupon/Partner Code</span> </p>}

                                <div class="col-12 mt-3">
                                    {action.btnLoader ? <button type="button" className="btn btn-primary btn-lg w-100" disabled><div class="spinner-border" role="status" style={{ width: "20px", height: "20px" }}></div></button> : <button type="submit" className="btn btn-primary btn-lg w-100" onClick={() => subbtn.current.click()} disabled={((action?.haveCoupon && !data?.couponValue) || (action.wpCredit && !data.creditValue)) ? true : false}> Submit</button>}
                                </div>
                                <label htmlFor="submitform" class="col-12">
                                    <p class="text-center font-rubik copyright-text font-13 themecolor"><i className="bi bi-shield-fill-check  text-success mr-1"></i>Safe & Secure Payment</p>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}
